import type { SupplierAccountOption } from '../../../../hooks/useFetchCreditorBalanceSummaryAccounts'

const getAccountLabel = (account: SupplierAccountOption): string => account.accountNumber || account.name

export const formatAccountsPreview = (selectedIds: string[], accounts: SupplierAccountOption[]): string | undefined => {
  if (selectedIds.length === 0) {
    return undefined
  }

  const labelByContactId = new Map(accounts.map((account) => [account.contactId, getAccountLabel(account)]))

  return selectedIds.map((id) => labelByContactId.get(id) ?? id).join(', ')
}
